/* Naguirre — acessibilidade (04/10/2026): teclado e leitor de tela.
   Para quem usa toque ou mouse nada muda na tela. Este arquivo não cria clique por conta própria:
   só repete, para quem usa teclado, o que o clique da cliente faria.
   1) Anel de foco só para quem navega com Tab (classe ng-teclado no <html>; o anel está em
      naguirre-acessibilidade.css). Sai no primeiro clique ou toque.
   2) Gavetas do carrinho e do menu e a barra lateral do celular (filtros da coleção, menu do blog): ao
      abrir, o foco vai para o "Fechar"; o Tab não sai dela; Esc fecha tirando a classe do <body>, como o X
      do tema; ao fechar, o foco volta para onde estava. O "Voltar fecha a gaveta" do naguirre-carrinho.js
      segue igual (ele observa a mesma classe).
   3) aria-expanded do botão do menu (também quando fecha tocando no fundo) e dos botões da barra lateral.
   4) Busca do cabeçalho no computador: Enter/Espaço na lupa abrem como o clique do mouse; Esc fecha.
   5) Tamanho e cor escolhidos pelo teclado liberam o "Adicionar" (o tema só liberava no clique do mouse).
   6) Enter/Espaço nos controles que não são botões de verdade (marcados com data-ng-tecla no Liquid).
   7) "N itens" do carrinho que o leitor de tela lê acompanha o número visível.
   8) Setas do banner da home com nome em português. */
(function () {
  'use strict';

  var html = document.documentElement;
  var body = document.body;
  if (!body || !window.MutationObserver || !Element.prototype.closest || !Element.prototype.matches) return;

  function focar(el) {
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }
  function visivel(el) {
    return !!(el && el.getClientRects().length && window.getComputedStyle(el).visibility !== 'hidden');
  }
  function cada(seletor, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(seletor), fn);
  }

  // ---------- 1) Teclado x clique/toque ----------
  var TECLADO = 'ng-teclado';
  function teclado() { return html.classList.contains(TECLADO); }
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Tab' && !ev.altKey && !ev.ctrlKey && !ev.metaKey && !teclado()) html.classList.add(TECLADO);
  }, true);
  // mousedown também chega depois de um toque. Sem touchstart de propósito: no iPhone ele ligaria :active.
  document.addEventListener('mousedown', function () {
    if (teclado()) html.classList.remove(TECLADO);
  }, true);

  // ---------- 2) Gavetas (carrinho, menu) e barra lateral do celular ----------
  var FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), ' +
    'textarea:not([disabled]), summary, iframe, [tabindex]:not([tabindex="-1"])';
  var gavetas = [
    // porCima: pop-ups do tema que abrem sobre a gaveta (a mesma lista que o tema usa para não fechar pelo fundo).
    { id: 'halo-cart-sidebar', classe: 'cart-sidebar-show', fechar: '[data-close-cart-sidebar]', porCima: ['edit-cart-show', 'term-condition-show', 'has-warning'] },
    { id: 'navigation-mobile', classe: 'menu_open', fechar: '[data-menu-close-sidebar]', porCima: [] },
    // Barra lateral do celular (filtros da coleção, menu do blog): só existe aberta abaixo de 1025 px.
    { id: 'halo-sidebar', classe: 'open-mobile-sidebar', fechar: '[data-close-sidebar]', porCima: [] }
  ];
  var ultima = null;
  gavetas.forEach(function (g) { g.aberta = body.classList.contains(g.classe); g.retorno = null; });

  function raizDe(g) { return document.getElementById(g.id); }
  function coberta(g) {
    return g.porCima.some(function (c) { return body.classList.contains(c); });
  }
  function gavetaAberta() {
    if (ultima && body.classList.contains(ultima.classe) && raizDe(ultima)) return ultima;
    for (var i = 0; i < gavetas.length; i++) {
      if (body.classList.contains(gavetas[i].classe) && raizDe(gavetas[i])) return gavetas[i];
    }
    return null;
  }
  // A página atrás da gaveta fica no .body-content-wrapper; pop-ups de apps ficam fora dele.
  function naPagina(el) {
    return !el || el === body || el === html || !!el.closest('.body-content-wrapper');
  }

  function aoAbrir(g) {
    var raiz = raizDe(g);
    if (!raiz) return;
    ultima = g;
    var ativo = document.activeElement;
    g.retorno = (ativo && ativo !== body && ativo !== html && !raiz.contains(ativo)) ? ativo : null;
    // A gaveta entra com transição: o foco vai para o "Fechar" assim que ele fica visível.
    var tentativas = 0;
    (function tentar() {
      if (!body.classList.contains(g.classe)) return;
      var botao = raiz.querySelector(g.fechar);
      if (botao && visivel(botao)) {
        if (!raiz.contains(document.activeElement)) focar(botao);
        return;
      }
      if (++tentativas < 40) window.requestAnimationFrame(tentar);
    })();
  }

  function aoFechar(g) {
    var raiz = raizDe(g);
    var volta = g.retorno;
    g.retorno = null;
    if (ultima === g) ultima = null;
    if (g.id === 'halo-cart-sidebar') lembrado = null;
    if (!raiz) return;
    var ativo = document.activeElement;
    var dentro = !!(ativo && raiz.contains(ativo));
    // Só mexe se o foco estava na gaveta (ou se perdeu); se a cliente já está em outro lugar, deixa.
    if (!dentro && ativo && ativo !== body && ativo !== html) return;
    if (volta && html.contains(volta) && visivel(volta)) focar(volta);
    else if (dentro && ativo.blur) ativo.blur();
  }

  function marcar(seletor, aberto) {
    var valor = aberto ? 'true' : 'false';
    cada(seletor, function (el) {
      if (el.getAttribute('aria-expanded') !== valor) el.setAttribute('aria-expanded', valor);
    });
  }
  function expandidos() {
    marcar('[data-mobile-menu]', body.classList.contains('menu_open'));
    marcar('[data-sidebar][aria-controls]', body.classList.contains('open-mobile-sidebar'));
  }

  new MutationObserver(function () {
    gavetas.forEach(function (g) {
      var agora = body.classList.contains(g.classe);
      if (agora === g.aberta) return;
      g.aberta = agora;
      if (agora) aoAbrir(g); else aoFechar(g);
    });
    expandidos();
  }).observe(body, { attributes: true, attributeFilter: ['class'] });
  expandidos();

  // Tab preso na gaveta aberta.
  function focaveis(raiz) {
    return Array.prototype.filter.call(raiz.querySelectorAll(FOCAVEIS), visivel);
  }
  var tab = null; // última tecla Tab dada com a gaveta aberta (para o focusin abaixo)
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Tab' || ev.altKey || ev.ctrlKey || ev.metaKey) return;
    var g = gavetaAberta();
    if (!g || coberta(g)) return;
    var raiz = raizDe(g);
    var ativo = document.activeElement;
    var dentro = raiz.contains(ativo);
    if (!dentro && !naPagina(ativo)) return; // foco num pop-up de app: não mexe
    var lista = focaveis(raiz);
    if (!lista.length) return;
    var primeiro = lista[0];
    var ultimo = lista[lista.length - 1];
    tab = { g: g, shift: ev.shiftKey, quando: Date.now() };
    if (!dentro) {
      ev.preventDefault();
      focar(ev.shiftKey ? ultimo : primeiro);
    } else if (ev.shiftKey && ativo === primeiro) {
      ev.preventDefault();
      focar(ultimo);
    } else if (!ev.shiftKey && ativo === ultimo) {
      ev.preventDefault();
      focar(primeiro);
    }
  });
  // Se mesmo assim o Tab levou o foco para fora (no Safari o Tab pula links, então o "último" muda),
  // ele volta para dentro da gaveta.
  document.addEventListener('focusin', function (ev) {
    var t = tab;
    tab = null;
    if (!t || Date.now() - t.quando > 500) return;
    var raiz = raizDe(t.g);
    if (!raiz || !body.classList.contains(t.g.classe) || coberta(t.g) || raiz.contains(ev.target)) return;
    var lista = focaveis(raiz);
    if (lista.length) focar(t.shift ? lista[lista.length - 1] : lista[0]);
  }, true);

  // Gaveta do carrinho redesenhada (ex.: + ou − na quantidade): para quem está no teclado, o foco volta
  // para o mesmo controle da mesma peça, em vez de se perder no topo da página.
  var MARCAS = ['data-plus-quantity-cart', 'data-minus-quantity-cart', 'data-cart-quantity', 'data-cart-remove'];
  var lembrado = null;
  var carrinho = document.getElementById('halo-cart-sidebar');
  var conteudo = carrinho && carrinho.querySelector('.previewCart-wrapper');
  function descrever(el) {
    for (var i = 0; i < MARCAS.length; i++) {
      if (el.hasAttribute && el.hasAttribute(MARCAS[i])) {
        var linha = el.closest('[data-item-row]');
        var chave = linha && linha.querySelector('[data-line]');
        return { marca: MARCAS[i], linha: chave ? chave.getAttribute('data-line') : null };
      }
    }
    return null;
  }
  function reencontrar(d) {
    if (!d || !d.linha) return null;
    var linhas = carrinho.querySelectorAll('[data-item-row]');
    for (var i = 0; i < linhas.length; i++) {
      var chave = linhas[i].querySelector('[data-line]');
      if (chave && chave.getAttribute('data-line') === d.linha) {
        var alvo = linhas[i].querySelector('[' + d.marca + ']');
        return visivel(alvo) ? alvo : null;
      }
    }
    return null;
  }
  if (carrinho && conteudo) {
    carrinho.addEventListener('focusin', function (ev) { lembrado = descrever(ev.target); });
    new MutationObserver(function () {
      if (!teclado() || !body.classList.contains('cart-sidebar-show')) return;
      var ativo = document.activeElement;
      if (ativo && ativo !== body && ativo !== html && html.contains(ativo)) return;
      var alvo = reencontrar(lembrado) || carrinho.querySelector('[data-close-cart-sidebar]');
      if (alvo) focar(alvo);
    }).observe(conteudo, { childList: true, subtree: true });
  }

  // ---------- 4) Busca do cabeçalho (computador) ----------
  // O tema só abre a busca no clique em cima do ícone (<svg class="icon-search">). Pelo teclado o clique
  // cai na <summary> e o próprio tema fecha na hora. Depois de um clique de teclado (detail 0), o tema
  // recebe o clique no ícone só pelo jQuery: nenhum evento novo no navegador.
  document.addEventListener('click', function (ev) {
    if (ev.detail !== 0 || !ev.isTrusted || window.innerWidth < 1025 || !window.jQuery) return;
    var lupa = ev.target.closest && ev.target.closest('summary[data-search-menu]');
    var icone = lupa && lupa.querySelector('.icon-search');
    if (!icone) return;
    window.setTimeout(function () { window.jQuery(icone).trigger('click'); }, 0);
  });
  function fecharBusca() {
    var aberta = document.querySelector('[class*="section-header-"].sticky-search-menu-open');
    if (!aberta || !window.jQuery) return false;
    var lupa = aberta.querySelector('summary[data-search-menu]');
    var dentro = aberta.contains(document.activeElement);
    window.jQuery(document).trigger('click.hideSearchSticky'); // o mesmo fechamento do clique fora da busca
    if (dentro && lupa) focar(lupa);
    return true;
  }

  // Esc: fecha o que estiver aberto por cima da página.
  document.addEventListener('keydown', function (ev) {
    if ((ev.key !== 'Escape' && ev.key !== 'Esc') || ev.defaultPrevented || ev.isComposing) return;
    var g = gavetaAberta();
    if (g) {
      if (!coberta(g)) body.classList.remove(g.classe); // igual ao X do tema
      return;
    }
    fecharBusca();
  });

  // ---------- 5) Tamanho e cor pelo teclado ----------
  // O tema exige escolher o tamanho (classe block-swatch no grupo) e só tirava a classe no clique do mouse
  // no rótulo. Setas e Espaço no radio também contam (Espaço no tamanho que já vinha marcado não gera
  // clique nenhum, por isso o keydown). Cliques simulados por código (como a pré-seleção da página do
  // produto) não entram aqui (isTrusted), para não mudar nada do que acontece hoje.
  function escolheu(ev) {
    var radio = ev.target;
    if (!ev.isTrusted || !radio || !radio.matches || !radio.matches('input.product-form__radio')) return;
    if (ev.type === 'keydown' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
    var grupo = radio.closest('.product-form__input');
    if (grupo) {
      grupo.classList.remove('block-swatch');
      grupo.classList.remove('classe-erro');
    }
  }
  document.addEventListener('change', escolheu);
  document.addEventListener('click', escolheu);
  document.addEventListener('keydown', escolheu);

  // ---------- 6) Enter/Espaço em controle que não é botão de verdade ----------
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
    var alvo = ev.target;
    if (!alvo || !alvo.matches || !alvo.matches('[data-ng-tecla]')) return;
    ev.preventDefault();
    if (!ev.repeat) alvo.click();
  });

  // ---------- 7) "N itens" do carrinho para o leitor de tela ----------
  // O número visível (aria-hidden) é atualizado pelo tema; o texto escondido ficava com o valor da carga da página.
  // Só vale para essa marcação: se o número já é lido direto (sem aria-hidden), não mexe em nada.
  cada('.cart-count-bubble [data-cart-count][aria-hidden="true"]', function (numero) {
    var oculto = numero.parentNode && numero.parentNode.querySelector('.visually-hidden');
    if (!oculto) return;
    function atualizar() {
      var n = parseInt(numero.textContent, 10);
      if (isNaN(n)) return;
      var texto = n === 1 ? '1 item' : n + ' itens';
      if (oculto.textContent !== texto) oculto.textContent = texto;
    }
    new MutationObserver(atualizar).observe(numero, { childList: true, characterData: true, subtree: true });
    atualizar();
  });

  // ---------- 8) Setas do banner da home (o Swiper põe "Next slide"/"Previous slide") ----------
  var SETAS = { 'Next slide': 'Próximo banner', 'Previous slide': 'Banner anterior' };
  cada('.slider-home .swiper-button-next, .slider-home .swiper-button-prev', function (seta) {
    function traduzir() {
      var nome = SETAS[seta.getAttribute('aria-label')];
      if (nome) seta.setAttribute('aria-label', nome);
    }
    new MutationObserver(traduzir).observe(seta, { attributes: true, attributeFilter: ['aria-label'] });
    traduzir();
  });
})();
